import PropTypes from 'prop-types';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import MissingLabel from 'automation-ui-core/components/MissingLabel';
import CreateTaskActionMetadata from 'automation-ui-action-features/actions/create-task/records/CreateTaskActionMetadata';
import PersonalizedTextView from 'automation-ui-action-features/personalized-text/PersonalizedTextView';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateTaskTitleLabel = ({
  actionMetadata,
  flowObjectTypeId
}) => {
  const {
    subject
  } = actionMetadata;
  return subject ? /*#__PURE__*/_jsx(PersonalizedTextView, {
    propertyTypeId: flowObjectTypeId,
    text: subject
  }) : /*#__PURE__*/_jsx(MissingLabel, {
    type: "title"
  });
};
CreateTaskTitleLabel.propTypes = {
  actionMetadata: PropTypes.instanceOf(CreateTaskActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType
};
export default CreateTaskTitleLabel;